<template>
  <div class="applet-contain">
    <p class="title">单次购买-{{ target.name }}</p>
    <template>
      <span class="date">{{ item.createdAt | dateFormat }}创建的订单</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AppletContain',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    target () {
      return this.item.target
    }
  }
}
</script>

<style scoped lang="scss">
.applet-contain {
  .title {
    @include sc($font-size-lg, $color-text-heavy);
    padding-bottom: 8px;
  }
  .date {
    @include sc($font-size-md, $color-text-light);
  }
}
</style>
